<template>
  <div>
    <q-select
      dense
      outlined
      :model-value="props.modelValue"
      @update:model-value="(value) => $emit('update:modelValue', value)"
      :options="listaGrupos"
      option-label="description"
      option-value="id"
      label="Selecione o Grupo"
      label-color="grey-6"
      :disable="disable"
      behavior="menu"
      map-options
      borderless
      use-input
      @filter="filtrar"
      :display-value="
        modelValue?.description?.length > 9
          ? `${modelValue?.description?.substring(0, 9)}....`
          : modelValue?.description
      "
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section>Nenhum resultado</q-item-section>
        </q-item>
      </template>
      <q-tooltip v-if="modelValue">
        {{ props?.modelValue?.description }}
      </q-tooltip>
    </q-select>
  </div>
</template>

<script setup>
// @TODO Alterar para usar o "defineModel" das ultimas versões do vue
import { /*defineModel*/ ref, defineProps } from "vue";
import { useStore } from "vuex";

const store = useStore();
const props = defineProps({
  modelValue: {},
  disable: {
    type: Boolean,
    default: false,
  },
});

const listaGrupos = ref([]);

const listarGrupos = async (val) => {
  listaGrupos.value = [];
  try {
    const response = await store.dispatch("compras/getGrupos", {
      vendor_id: store.state.org.unidadeData.id,
      search: val,
      page: 1,
    });

    listaGrupos.value = response.data.results.data;
  } catch (error) {
    console.log(error);
  }
};

const filtrar = async (val, update) => {
  await listarGrupos(val);
  update();
};
</script>
